const DateFormat = (date, time) => {
  if (date) {
    return `${date.split('.')[2]}-${date.split('.')[1]}-${date.split('.')[0]}T${time}`;
  }
  return '';
};

export default DateFormat;



// WEBPACK FOOTER //
// ./src/utils/DateFormat.js